import React from 'react';
import cx from 'classnames';

import Bone from 'app/shared/components/Bone';
import PDPContentSkeleton from 'app/shared/components/skeletons/PDPContentSkeleton';
import Breadcrumb from 'app/shared/components/Breadcrumb';

import pathsManifest from 'app/shared/pathsManifest';

// Multibrand-UI Components
import PageCometTemp from '@zg-rentals/multibrand-ui/lib/PageCometTemp';
import {
    Tabs, TabList, Tab, TabPanel,
} from '@zg-rentals/multibrand-ui/lib/Tabs';

import {
    StyledBreadcrumb,
    StyledPhotoTabsSkeletonContainer,
    StyledContainer,
} from './StyledComponents';

import './style.scss';

const paths = pathsManifest.getAllPaths();

const PropertyDetailsPageSkeleton = () => (
    <div className="PropertyDetailsPageSkeleton">
        <PageCometTemp
            contentClassName="PDP-page"
            hideFooter={true}
            hideHeader={true}
        >
            <StyledBreadcrumb>
                <PageCometTemp.AboveContent>
                    <Breadcrumb title="My properties" redirectTo={paths.propertiesPage} />
                </PageCometTemp.AboveContent>
            </StyledBreadcrumb>

            <StyledPhotoTabsSkeletonContainer>
                <div className="PDP-photoGridContainer">
                    <div
                        className={cx([
                            'PhotoGrid',
                            'PhotoGrid-size-0',
                        ])}
                    />
                    <div className="PDP-photoContent">
                        <div className="PDP-badge">
                            <Bone type="line" />
                        </div>
                        <div className="PDP-full-address-container">
                            <div className="PDP-address-container">
                                <Bone type="line" />
                            </div>
                        </div>
                        <div className="PDP-cityStateZip">
                            <Bone type="line" />
                        </div>
                    </div>
                </div>

                <Tabs defaultIndex={0}>
                    <TabList>
                        <Tab name="Listing">Listing</Tab>
                        <Tab name="Messages">Messages</Tab>
                    </TabList>

                    <TabPanel />
                    <TabPanel />
                </Tabs>

                <StyledContainer>
                    <PDPContentSkeleton />
                </StyledContainer>
            </StyledPhotoTabsSkeletonContainer>
        </PageCometTemp>
    </div>
);

export default PropertyDetailsPageSkeleton;
